
import React, { useState, useEffect, useRef } from 'react';
import { useCounterAnimation } from '../hooks/useCounterAnimation';

const AnimatedCounter = ({ value, duration = 2000, suffix = "", className = "", style = {} }) => {
  const [isVisible, setIsVisible] = useState(false);
  const elementRef = useRef();

  // Extract numeric value
  const numericValue = typeof value === 'string' ? parseInt(value) : value;
  const currentValue = useCounterAnimation(numericValue, duration, isVisible);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={elementRef} className={className} style={style}>
      {currentValue}{suffix}
    </div>
  );
};

export default AnimatedCounter;
